module.exports = __webpack_public_path__ + "img/MESSAGE.7f474ed7.svg";